module.exports = __webpack_public_path__ + "images/the-model-19c9bbc958e4bd351706cdd736df8ed9.png";